import React from 'react';
import PropTypes from 'prop-types';
import { formatDate } from 'helpers/formatters/date_time_formats';
import Dropdown from 'components/dropdown';
import { faClone, faPenToSquare } from '@fortawesome/pro-regular-svg-icons';
import { faEye } from '@fortawesome/pro-solid-svg-icons';

export default function DocTemplateRow({ template, canDuplicate, onAccessTemplateReport, onDuplicate, onDelete }) {
  return (
    <tr>
      <td className="align-middle">
        <a href={template.editPath}>{template.name}</a>
      </td>
      <td className="align-middle">
        {template.createdByName || 'Buildout Defaults'}
      </td>
      <td className="align-middle">
        {formatDate(template.updatedAt)}
      </td>
      <td className="align-middle">
        {template.editedByName || '---'}
      </td>
      <Dropdown.Cell style={{ height: 'auto' }}>
        <Dropdown.Item
          icon={faPenToSquare}
          label="Edit Default"
          onClick={() => { window.location.href = template.editPath; }}
        />
        {canDuplicate && (
          <Dropdown.Item
            data-testid="duplicate-template-button"
            icon={faClone}
            label="Duplicate"
            onClick={() => onDuplicate(template)}
          />
        )}
        {template.deletePath && (
          <Dropdown.Item
            isDelete
            label="Delete"
            onClick={() => onDelete(template)}
          />
        )}
        {onAccessTemplateReport && (
          <Dropdown.Item
            icon={faEye}
            label="Access Report"
            onClick={() => onAccessTemplateReport(template)}
          />
        )}
      </Dropdown.Cell>
    </tr>
  );
}

DocTemplateRow.propTypes = {
  canDuplicate: PropTypes.bool.isRequired,
  template: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    editPath: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
    deletePath: PropTypes.string,
    createdByName: PropTypes.string,
    editedByName: PropTypes.string
  }).isRequired,
  onAccessTemplateReport: PropTypes.func,
  onDelete: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired
};
